<homey-text-page>
  <homey-paragraphs>
    <div>
      <homey-page-title title="Terms & Conditions"/>
      <p>
        These terms and conditions apply to the Homey - NYC Housing Lottery Made Easy app (hereby referred to as
        "Application")
        for mobile devices that was created by Homey Affordable Housing, Inc. (hereby referred to as "Service Provider")
        as
        a Commercial service.
      </p>
    </div>

    <p>
      Upon downloading or utilizing the Application, you are automatically agreeing to the following terms. It is
      strongly
      advised that you
      thoroughly read and understand these terms prior to using the Application. Unauthorized copying, modification of
      the
      Application, any part
      of the Application, or our trademarks is strictly prohibited. Any attempts to extract the source code of the
      Application, translate the
      Application into other languages, or create derivative versions are not permitted. All trademarks, copyrights,
      database rights, and other intellectual property rights related to the Application remain the property of the
      Service Provider.
    </p>

    <p>
      By creating a Homey account, you give the service provider the full legal authority to create a Housing Connect /
      NYC.ID account for you, and to submit housing lottery applications in your name.
    </p>

    <p>
      The Service Provider is dedicated to ensuring that the Application is as beneficial and efficient as possible. As
      such, they reserve the right
      to modify the Application or charge for their services at any time and for any reason. The Service Provider
      assures
      you that any charges for
      the Application or its services will be clearly communicated to you.
    </p>

    <p>
      The Application stores and processes personal data that you have provided to the Service Provider in order to
      provide the Service. It is your
      responsibility to maintain the security of your phone and access to the Application. The Service Provider strongly
      advise against jailbreaking
      or rooting your phone, which involves removing software restrictions and limitations imposed by the official
      operating system of your device.
      Such actions could expose your phone to malware, viruses, malicious programs, compromise your phone's security
      features, and may result in the
      Application not functioning correctly or at all.
    </p>

    <div>
      <p>
        Please note that the Application utilizes third-party services that have their own Terms and Conditions. Below
        are
        the links to the Terms
        and Conditions of the third-party service providers used by the Application:
      </p>
      <a class="underline block" href="https://policies.google.com/terms">Google Play Services</a>
    </div>

    <p>
      Please be aware that the Service Provider does not assume responsibility for certain aspects. Some functions of
      the
      Application require an active
      internet connection, which can be Wi-Fi or provided by your mobile network provider. The Service Provider cannot
      be
      held responsible if the
      Application does not function at full capacity due to lack of access to Wi-Fi or if you have exhausted your data
      allowance.
    </p>

    <p>
      If you are using the application outside of a Wi-Fi area, please be aware that your mobile network provider's
      agreement terms still apply.
      Consequently, you may incur charges from your mobile provider for data usage during the connection to the
      application, or other third-party charges.
      By using the application, you accept responsibility for any such charges, including roaming data charges if you
      use
      the application outside of your
      home territory (i.e., region or country) without disabling data roaming. If you are not the bill payer for the
      device on which you are using the
      application, they assume that you have obtained permission from the bill payer.
    </p>

    <p>
      Similarly, the Service Provider cannot always assume responsibility for your usage of the application. For
      instance,
      it is your responsibility to ensure
      that your device remains charged. If your device runs out of battery and you are unable to access the Service, the
      Service Provider cannot be held
      responsible.
    </p>

    <p>
      In terms of the Service Provider's responsibility for your use of the application, it is important to note that
      while they strive to ensure that it is
      updated and accurate at all times, they do rely on third parties to provide information to them so that they can
      make it available to you. The Service
      Provider accepts no liability for any loss, direct or indirect, that you experience as a result of relying
      entirely
      on this functionality of the application.
    </p>

    <p>
      The Service Provider may wish to update the application at some point. The application is currently available as
      per
      the requirements for the operating
      system (and for any additional systems they decide to extend the availability of the application to) may change,
      and
      you will need to download the
      updates if you want to continue using the application. The Service Provider does not guarantee that it will always
      update the application so that it is
      relevant to you and/or compatible with the particular operating system version installed on your device. However,
      you agree to always accept updates
      to the application when offered to you. The Service Provider may also wish to cease providing the application and
      may terminate its use at any time without
      providing termination notice to you. Unless they inform you otherwise, upon any termination, (a) the rights and
      licenses granted to you in these terms will
      end; (b) you must cease using the application, and (if necessary) delete it from your device.
    </p>
  </homey-paragraphs>

  <div>
    <homey-page-subtitle title="Additional Restrictions on Eligibility"/>
    <homey-paragraphs>
      <p>
        Certain individuals and entities are prohibited from using Homey to apply for or obtain an affordable housing
        unit.
        These include:
      </p>
      <p>
        a. The Developer and the Developer’s family members, employees, agents, and employees of agents, including:
      </p>
      <div>
        i. Any person holding an equity interest in the Developer or any agent of the Developer;
        <p>
          ii. Any director, officer, member, or employee of the Developer or any agent of the Developer;
        </p>
        <p>
          iii. The spouse of any such person;
        </p>
        <p>
          iv. Any of their respective siblings, parents, grandparents, children, or grandchildren; or
        </p>
        <p>
          v. Their respective spouses.
        </p>
      </div>
      <p>
        b. Employees of HDC are prohibited from seeking a unit in any project in which HDC is involved.
      </p>
      <p>
        c. Employees of HPD may not seek units in buildings that have been involved in HPD programs or projects in the
        last
        three years if the employee:
      </p>

      <div>
        <p>i. Works in the division that administers such HPD program or project;</p>
        <p>ii. Works in the Marketing Unit;</p>
        <p>iii. Is or was involved in decisions concerning such HPD program or project; or</p>
        <p>iv. Seeks, obtains, or purchases the housing through a process that is different from the process through
          which
          members of the general public seek, obtain, or purchase such housing.</p>
      </div>
      <p>d. Any HPD employee who is invited to confirm their eligibility for a lottery project must consult with the
        agency's
        Office of Legal Affairs to determine whether the City Charter, HPD policies or orders, or any other law or rule
        regarding conflicts of interest prohibits such employee from leasing or purchasing the apartment or home. The
        employee
        will be required to submit a statement from HPD that receiving such a unit does not present a conflict of
        interest.</p>
      <p>By using Homey, you acknowledge and agree to these restrictions and confirm that you do not fall into any of
        the
        prohibited categories outlined above.</p>
      <p>
        Applicants must not use Homey to apply for a housing lottery for which they have already submitted, or plan to
        submit, a separate application through another method. Submitting multiple applications for the same lottery may
        lead to disqualification from consideration. Users are responsible for ensuring compliance with this rule to
        avoid
        jeopardizing their eligibility.
      </p>
      <p>
        By using Homey, you agree that we may contact you, including via email, phone, or in-app notifications, to ask
        about your experience with our service. This applies to all users, including recent customers, in order to help
        us
        improve Homey for everyone.
      </p>
    </homey-paragraphs>
  </div>
  <div>
    <homey-page-subtitle title="Limitation of Liability"/>
    <p>Homey Affordable Housing Inc. provides tools and services to assist users in applying for affordable housing
      opportunities; however, we do not guarantee the outcome of any application, including but not limited to winning a
      housing lottery, securing an apartment, or receiving any form of financial or housing benefit. Homey Affordable
      Housing Inc. is not responsible or liable for any losses—monetary, emotional, or otherwise—that may result from
      the
      use of our service, including but not limited to application errors, technical malfunctions, or user mistakes. By
      using our service, you acknowledge and agree that Homey Affordable Housing Inc. bears no liability for any direct,
      indirect, incidental, consequential, or special damages arising from or related to your use of the service.</p>
  </div>
  <div>
    <homey-page-subtitle title="Changes to These Terms and Conditions"/>
    <homey-paragraphs>
      <p>
        The Service Provider may periodically update their Terms and Conditions. Therefore, you are advised to review
        this
        page regularly for any changes.
        The Service Provider will notify you of any changes by posting the new Terms and Conditions on this page.
      </p>
      <p>
        These terms and conditions are effective as of 2025-02-06
      </p>
    </homey-paragraphs>
  </div>

  <div>
    <homey-page-subtitle title="Contact Us"/>
    <p>
      If you have any questions or suggestions about the Terms and Conditions, please do not hesitate to contact the
      Service Provider at
      <a class="underline" href="mailto:contact@myhomey.io">contact&#64;myhomey.io</a>.
    </p>
  </div>
</homey-text-page>
